import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Milestone } from '@/models/leaderboard';
import { getFullMonthName } from '@/helpers';
import { ui } from '@/constants';

type CalloutDirection = 'up' | 'down';

@Component({
  name: 'CmgLeaderboardMilestones',
})
export default class CmgLeaderboardMilestones extends Vue {
  hoveredMilestoneIndex: number | null = null;
  clickedMilestoneIndex: number | null = null;

  readonly milestonePositions: Record<number, { desktop: object[], mobile: object[] }> = {
    5: { // June (zero-indexed)
      desktop: [
        { top: '26.71102662%', left: '17.34587252%', transform: 'translate(-50%, -50%)' },
        { top: '40.08745247%', left: '40.96133751%', transform: 'translate(-50%, -50%)' },
        { top: '25%',          left: '84.11703239%', transform: 'translate(-50%, -50%)' },
        { top: '53.13688213%', left: '81.19122257%', transform: 'translate(-50%, -50%)' },
        { top: '79.94296578%', left: '24.66039707%', transform: 'translate(-50%, -50%)' },
        { top: '87.35741445%', left: '51.82863114%', transform: 'translate(-50%, -50%)' },
        { top: '75.38022814%', left: '84.84848485%', transform: 'translate(-50%, -50%)' },
      ],
      mobile: [
        { top: '15.0%', left: '15.9%', transform: 'translate(-50%, -50%)' },
        { top: '35.3%', left: '41.1%', transform: 'translate(-50%, -50%)' },
        { top: '19.0%', left: '74.9%', transform: 'translate(-50%, -50%)' },
        { top: '45.0%', left: '73.9%', transform: 'translate(-50%, -50%)' },
        { top: '55.2%', left: '20.3%', transform: 'translate(-50%, -50%)' },
        { top: '71.7%', left: '46.9%', transform: 'translate(-50%, -50%)' },
        { top: '65.6%', left: '83.1%', transform: 'translate(-50%, -50%)' },
      ],
    },
    6: { // July (zero-indexed)
      desktop: [
        { top: '20.81749049%', left: '19.85370951%', transform: 'translate(-50%, -50%)' },
        { top: '51.80608365%', left: '26.95924765%', transform: 'translate(-50%, -50%)' },
        { top: '79.56273764%', left: '19.33124347%', transform: 'translate(-50%, -50%)' },
        { top: '84.50570342%', left: '41.79728318%', transform: 'translate(-50%, -50%)' },
        { top: '73.47908745%', left: '61.75548589%', transform: 'translate(-50%, -50%)' },
        { top: '31.08365019%', left: '59.03866249%', transform: 'translate(-50%, -50%)' },
        { top: '23%', left: '80.87774295%', transform: 'translate(-50%, -50%)' },
      ],
      mobile: [
        { top: '15.1%', left: '18.3%', transform: 'translate(-50%, -50%)' },
        { top: '46.1%', left: '27.4%', transform: 'translate(-50%, -50%)' },
        { top: '68.4%', left: '12.8%', transform: 'translate(-50%, -50%)' },
        { top: '72.4%', left: '43.2%', transform: 'translate(-50%, -50%)' },
        { top: '50.9%', left: '64.0%', transform: 'translate(-50%, -50%)' },
        { top: '27.7%', left: '46.6%', transform: 'translate(-50%, -50%)' },
        { top: '17.7%', left: '82.1%', transform: 'translate(-50%, -50%)' },
      ],
    },
    7: { // August (zero-indexed)
      desktop: [
        { top: '16.25475285%', left: '27.79519331%', transform: 'translate(-50%, -50%)' },
        { top: '30.70342205%', left: '75.44409613%', transform: 'translate(-50%, -50%)' },
        { top: '36.02661597%', left: '13.06165099%', transform: 'translate(-50%, -50%)' },
        { top: '61.31178707%', left: '21.31661442%', transform: 'translate(-50%, -50%)' },
        { top: '53.3269962%',  left: '63.2183908%',  transform: 'translate(-50%, -50%)' },
        { top: '76.71102662%', left: '81.6091954%',  transform: 'translate(-50%, -50%)' },
        { top: '88.11787072%', left: '35.42319749%', transform: 'translate(-50%, -50%)' },
      ],
      mobile: [
        { top: '14.6%', left: '27.4%', transform: 'translate(-50%, -50%)' },
        { top: '22.0%', left: '78.1%', transform: 'translate(-50%, -50%)' },
        { top: '31.0%', left: '19.1%', transform: 'translate(-50%, -50%)' },
        { top: '51.9%', left: '27.4%', transform: 'translate(-50%, -50%)' },
        { top: '46.6%', left: '73.1%', transform: 'translate(-50%, -50%)' },
        { top: '64.6%', left: '84.7%', transform: 'translate(-50%, -50%)' },
        { top: '74.5%', left: '41.3%', transform: 'translate(-50%, -50%)' },
      ],
    },
  };

  readonly milestoneRotations: Record<number, { desktop: string[], mobile: string[] }> = {
    5: { // June (zero-indexed)
      desktop: [
        'rotate(13deg)', 'rotate(-12.23deg)', 'rotate(-13deg)', 'rotate(-6.53deg)',
        'rotate(-6.53deg)', 'rotate(-4.39deg)', 'rotate(6.72deg)',
      ],
      mobile: [
        'rotate(13.02deg)', 'rotate(-12deg)', 'rotate(16.73deg)', 'rotate(-18.02deg)',
        'rotate(20.33deg)', 'rotate(-20.31deg)', 'rotate(10.56deg)',
      ],
    },
    6: { // July (zero-indexed)
      desktop: [
        'rotate(3.74deg)', 'rotate(-6.53deg)', 'rotate(13deg)', 'rotate(10.55deg)',
        'rotate(0.5deg)', 'rotate(-6.53deg)', 'rotate(13deg)',
      ],
      mobile: [
        'rotate(13.02deg)', 'rotate(-15.18deg)', 'rotate(13deg)', 'rotate(11.65deg)',
        'rotate(-0.8deg)', 'rotate(-14.33deg)', 'rotate(13.02deg)',
      ],
    },
    7: { // August (zero-indexed)
      desktop: [
        'rotate(13deg)', 'rotate(-13deg)', 'rotate(-13deg)', 'rotate(15deg)',
        'rotate(-7deg)', 'rotate(-17deg)', 'rotate(17deg)',
      ],
      mobile: [
        'rotate(13.02deg)', 'rotate(-17.89deg)', 'rotate(-14.33deg)', 'rotate(29.81deg)',
        'rotate(-2.6deg)', 'rotate(-11.31deg)', 'rotate(9.08deg)',
      ],
    },
  };

  readonly milestoneCalloutDirections: Record<number, CalloutDirection[]> = {
    5: [ // June (zero-indexed)
      'down', 'down', 'down', 'down', 'up', 'up', 'up',
    ],
    6: [ // July (zero-indexed)
      'down', 'down', 'up', 'up', 'up', 'down', 'down',
    ],
    7: [ // August (zero-indexed)
      'down', 'down', 'down', 'down', 'down', 'up', 'up',
    ],
  };

  get activeMilestonePositions(): object[] {
    const monthPositions = this.milestonePositions[this.currentMonthIndex];
    return this.isMobile ? monthPositions.mobile : monthPositions.desktop;
  }

  get activeBadgeRotations(): string[] {
    const rotations = this.milestoneRotations[this.currentMonthIndex];
    return this.isMobile ? rotations.mobile : rotations.desktop;
  }

  get activeCalloutDirections(): CalloutDirection[] {
    return this.milestoneCalloutDirections[this.currentMonthIndex];
  }

  getBadgeStyle(index: number): object {
    return { transform: this.activeBadgeRotations[index] };
  }

  getCalloutDirectionClass(index: number): string {
    return `callout-${this.activeCalloutDirections[index]}`;
  }

  get nextMilestoneIndex(): number {
    return this.milestonesData.findIndex(milestone => !milestone.isCompleted);
  }

  getCalloutBoxStyle(index: number): object {
    const position = this.activeMilestonePositions[index] as any;
    const leftPercent = parseFloat(position.left);
    const containerWidth = this.$el?.clientWidth || 0;
    const badgeCenterPx = (leftPercent / 100) * containerWidth;
    const boxWidth = 358;
    const triangleEdgePadding = 24;

    // Desired target: 
      // mobile or desktop center = container center
      // desktop = nearest container edge
    const desiredCenterPx = this.isMobile || leftPercent > 35 && leftPercent < 65
      ? containerWidth / 2
      : leftPercent <= 35 ? boxWidth / 2 : containerWidth - boxWidth / 2;

    // Clamp 1: triangle must stay inside the box
    // Clamp 2: box must stay inside the container
    const maxBoxOffset = boxWidth / 2 - triangleEdgePadding;
    const targetCenterPx = Math.max(
      boxWidth / 2,
      Math.min(
        containerWidth - boxWidth / 2,
        Math.max(badgeCenterPx - maxBoxOffset, Math.min(badgeCenterPx + maxBoxOffset, desiredCenterPx)),
      ),
    );

    return {
      transform: `translateX(${targetCenterPx - badgeCenterPx}px)`,
    };
  }
    
  isNextMilestone(index: number): boolean {
    return index === this.nextMilestoneIndex;
  }

  isCalloutVisible(index: number): boolean {
    return this.hoveredMilestoneIndex === index || this.clickedMilestoneIndex === index;
  }

  get isInErrorState(): boolean {
    return this.$appStore.state.leaderboard.isInErrorState;
  }

  get currentMonthIndex(): number {
    // To assist in testing - at least a month index of 5 - June since campaigns start in June, but development occurring in May
    return Math.max(5, new Date().getMonth());
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.tablet;
  }

  get leaderboardMapImg(): string | undefined {
    switch (this.currentMonthIndex) {
      case 5: // June (zero-indexed)
        return this.isMobile ? this.leaderboardMapJuneMobileUrl : this.leaderboardMapJuneDesktopUrl;
      case 6: // July (zero-indexed)
        return this.isMobile ? this.leaderboardMapJulyMobileUrl : this.leaderboardMapJulyDesktopUrl;
      case 7: // August (zero-indexed)
        return this.isMobile ? this.leaderboardMapAugustMobileUrl : this.leaderboardMapAugustDesktopUrl;
      default:
        return this.isMobile ? this.leaderboardMapJuneMobileUrl : this.leaderboardMapJuneDesktopUrl;
    }
  }

  get leaderboardMapJuneMobileUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapJune.mobile || '';
  }

  get leaderboardMapJuneDesktopUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapJune.desktop || '';
  }

  get leaderboardMapJulyMobileUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapJuly.mobile || '';
  }

  get leaderboardMapJulyDesktopUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapJuly.desktop || '';
  }

  get leaderboardMapAugustMobileUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapAugust.mobile || '';
  }

  get leaderboardMapAugustDesktopUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapAugust.desktop || '';
  }

  get leaderboardMapCalloutTriangleUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapCalloutTriangle.default || '';
  }

  get leaderboardMapCalloutBoxUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardMapCalloutBox.default || 'undefined';
  }

  get month(): string {
    return getFullMonthName(new Date(2025, this.currentMonthIndex, 1));
  }

  get currentMonthCampaign() {
    return this.$appStore.state.leaderboard.summerCampaigns.find(x => x.month === this.currentMonthIndex);
  }

  get milestonesData(): { imageUrl: string; isCompleted: boolean; title: string; description: string }[] {
    const milestones = this.currentMonthCampaign?.milestones ?? [];
    return milestones
      .map(milestone => ({
        imageUrl: milestone.completed ? milestone.mediaUri : milestone.mediaUriInactive,
        isCompleted: milestone.completed,
        title: milestone.title,
        description: milestone.description,
      }));
  }

  onMilestoneMouseEnter(index: number): void {
    if(!this.milestonesData[index].isCompleted) {
      // Only show hover if there's no active click
      if (this.clickedMilestoneIndex === null) {
        this.hoveredMilestoneIndex = index;
      }
    }
  }

  onMilestoneMouseLeave(index: number): void {
    if(!this.milestonesData[index].isCompleted) {
      // Only clear hover if it's the hovered milestone
      if (this.hoveredMilestoneIndex === index) {
        this.hoveredMilestoneIndex = null;
      }
    }
  }

  onMilestoneClick(index: number): void {
    if(!this.milestonesData[index].isCompleted) {
      this.clickedMilestoneIndex = this.clickedMilestoneIndex === index ? null : index;
    }
  }
}
